export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const PRODUCT_BANNER_IMAGE = "https://customer-assets.emergentagent.com/job_3ae66389-b093-4330-9743-6c6a00dc5113/artifacts/pb6dbmh1_website%20headers.webp";
